import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { AlteracaoDataAgendamento, AlteracaoDataMensagem } from '@/types/_'

@Module({ namespaced: true, name: 'ChatStore' })
export default class ChatStore extends VuexModule {
  solicitacaoId: string = ''
  validadePedido: string = ''
  private alteracaoDataAgendamentoDefault: AlteracaoDataAgendamento = {
    dataConfirmada: '',
    opcao1: '',
    opcao2: null,
    opcao3: null,
    solicitacaoId: '',
  }

  private alteracaoDataAgendamentoMensagensDefault: AlteracaoDataMensagem[] = []

  public alteracaoDataAgendamento: AlteracaoDataAgendamento = { ...this.alteracaoDataAgendamentoDefault }

  public alteracaoDataAgendamentoMensagens: AlteracaoDataMensagem[] = { ...this.alteracaoDataAgendamentoMensagensDefault }

  @Action
  async getDataAgendamento(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getDataAgendamentoChat(solicitacaoId)

    if (request.success) {
      this.context.commit('setSolicitacaoId', solicitacaoId)
      this.context.commit('setAlteracaoDataMensagens', request.data.mensagens)
      this.context.commit('setValidadePedido', request.data.solicitacao.autorizacaoValidade)
      return request.data
    }

    return {}
  }

  @Action
  async postAlteracaoDataAgendamento(alterarDataAgendamento: AlteracaoDataAgendamento) {
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.postAlteracaoDataAgendamento(this.solicitacaoId, alterarDataAgendamento)
    return request
  }

  @Action
  async sendDataAgendamentoMensagem(mensagem: AlteracaoDataMensagem) {
    this.context.commit('setAlteracaoDataMensagem', mensagem)
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.postDataAgendamentoMensagem(this.solicitacaoId, mensagem)

    return request
  }

  @Mutation
  setAlteracaoDataMensagem(mensagem: AlteracaoDataMensagem) {
    this.alteracaoDataAgendamentoMensagens.push(mensagem)
  }

  @Mutation
  clearAlteracaoDataAgendamentoMensagens() {
    this.alteracaoDataAgendamentoMensagens = [...this.alteracaoDataAgendamentoMensagensDefault]
  }

  @Mutation
  setAlteracaoDataMensagens(mensagem: AlteracaoDataMensagem[]) {
    this.alteracaoDataAgendamentoMensagens = mensagem
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.solicitacaoId = solicitacaoId
  }

  @Mutation
  setValidadePedido(validade: string) {
    this.validadePedido = validade
  }

  @Mutation
  clearAlteracaoDataAgendamento() {
    this.alteracaoDataAgendamentoMensagens = { ...this.alteracaoDataAgendamentoMensagensDefault }
  }
}
